<template>
  <div>
    <b-row class="wrapper-projects py-4">
      <b-col v-for="project in projects" :key="project.id" sm="12" md="6">
        <b-list-group class="project-list">
          <b-list-group-item
            class="my-2 p-3 cursor project-card"
            :class="{
              unabled: !project.state,
              done: projectIsDone(project.complete_task, project.tasks),
            }"
            @click="goToProjectTasks(project.id, project.title)"
          >
            <div class="d-flex align-items-center">
              <span class="label d-block mb-2 font-weight-bold w-75">
                {{ project.title }}
              </span>
              <div class="d-flex gap-2 w-50 align-items-center font-weight-600">
                <span class="material-icons-round">
                  event_available
                </span>
                <span >
                  {{ formatDate(project.due_date) }}
                </span>
                <a @click.stop="goToEdit(project.id)" class="material-icons dot-icon">
                  more_vert_icon
                </a>
              </div>
            </div>
            <div class="progress-wrap d-flex justify-content-between align-items-center">
              <b-progress
                class="rounded-pill w-100"
                :value="project.complete_task"
                :max="project.tasks"
              ></b-progress>
              <span class="ml-2"
                >{{ taskCountFormat(project.complete_task) }}/{{
                  taskCountFormat(project.tasks)
                }}</span
              >
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    projects: {
      type: Array,
      required: true,
    },
  },
  data: function() {
    return {};
  },
  methods: {
    goToProjectTasks(id, title) {
      this.$router.push({
        name: 'project-tasks',
        params: { projectId: id, projectName: title },
      });
    },
    goToEdit(id) {
      this.$router.push({
        name: 'createNewProject',
        query: { project: id },
      });
    },
    taskCountFormat(task) {
      return task < 10 ? `0${task}` : task;
    },
    projectIsDone(totalTasks, tasks) {
      return (totalTasks !== 0) & (totalTasks === tasks);
    },
    formatDate(dueDate) {
      const date = new Date(dueDate);
      if (isNaN(date)) {
        return null;
      }
      const month = date.toLocaleString('default', { month: 'long' });
      const day = date.getDate();
      const dateString = `${month} ${day}`;
      return dateString;
    },
  },
};
</script>

<style lang="scss" scoped>
.dot-icon{
  width: 15px;
  &:hover{
    background-color: transparent;
  }
}
</style>
